module.exports = __webpack_public_path__ + "static/HomePresentation-5ab9bdaa5e84c5c8cc0f21d92da891c0.png";